// Default menu settings configurations

export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  isExternalLink?: boolean;
  roleValue?: string;
  issupportExternalLink?: boolean;
  isStarterkitExternalLink?: boolean;
  badge: { type: string; value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
}

export interface MenuConfig {
  vertical_menu: {
    items: Partial<MenuItem>[];
  };
}

export const MenuSettingsConfig: MenuConfig = {
  vertical_menu: {
    items: [
      {
        title: 'Home',
        icon: 'la-home',
        roleValue: 'HOME_VIEW',
        page: '/dashboard',
      },
      // {
      //   icon: ' la la-home',
      //   title: 'Home',
      //   roleValue: 'CORPORATE_EMPLOYEE_VIEW',
      //   page: 'c/employee/dashboard',
      // },
      // {
      //   icon: ' la la-home',
      //   title: 'Home',
      //   roleValue: 'CORPORATE_ROOM_APPROVER_REQ_VIEW',
      //   page: 'c/approver/dashboard',
      // },
      // {
      //   icon: ' la la-home',
      //   title: 'Home',
      //   roleValue: 'CORPORATE_MASTER_VIEW',
      //   page: 'c/tdadmin-dashboard/dashboard',
      // },
      // {
      //   icon: ' la la-home',
      //   title: 'Home',
      //   roleValue: 'TDUSER_DASHBOARD_VIEW',
      //   page: 'c/tduser-dashboard/dashboard',
      // },
      // {
      //   icon: ' la la-home',
      //   title: 'Home',
      //   roleValue: 'HOTEL_CONFIRM_ROOM_BOOKING_VIEW',
      //   page: 'h/dashboard/dashboard',
      // },
      {},
      {},
      {},
      {},
      {
        title: 'Operations',
        roleValue: 'ADMIN_LEAD_MANAGEMENT_VIEW',
        icon: 'la la-sliders',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Lead Management',
              roleValue: 'ADMIN_LEAD_MANAGEMENT_VIEW',
              page: '/a/operations/lead',
            },
            {
              title: 'Link Clients',
              roleValue: 'ADMIN_LINK_CLIENT_VIEW',
              page: '/a/operations/clients',
            },
          ],
        },
      },
      {
        title: 'Management',
        icon: 'la-cogs',
        roleValue: 'USER_MANAGEMENT_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Hotels',
              page: '/a/management/hotel',
              roleValue: 'USER_MANAGEMENT_VIEW',
            },
            {
              title: 'Corporates',
              page: '/a/management/corporate',
              roleValue: 'USER_MANAGEMENT_VIEW',
            },
          ],
        },
      },
      {},
      {},
      {},
      {},
      {
        title: 'Reports',
        icon: 'la la-file-text-o',
        roleValue: 'ADMIN_REPORTS_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Acquisitions',
              roleValue: 'ADMIN_ACQUISITIONS_REPORTS_VIEW',
              page: '/a/reports/acquisition-report',
            },
            {
              title: 'Month-Wise Acquisitions',
              roleValue: 'ADMIN_MONTHLY_ACQUISITIONS_REPORTS_VIEW',
              page: '/a/reports/month-wise-acquisition-report',
            },
            {
              title: 'City-Wise Acquisitions',
              roleValue: 'ADMIN_CITY_ACQUISITIONS_REPORTS_VIEW',
              page: '/a/reports/city-wise-acquisition-report',
            },
            {
              title: 'Commissions',
              roleValue: 'ADMIN_COMMISSIONS_REPORTS_VIEW',
              page: '/a/reports/commissions-report',
            },
            {
              title: 'Corporate User Report',
              roleValue: 'ADMIN_CORPORATE_USER_REPORTS_VIEW',
              page: '/a/reports/corp-user-report',
            },
            {
              title: 'Hotel User Report',
              roleValue: 'ADMIN_HOTEL_USER_REPORTS_VIEW',
              page: '/a/reports/hotel-user-report',
            },
            {
              title: 'Client Churn Report',
              roleValue: 'ADMIN_CLIENT_CHURN_REPORTS_VIEW',
              page: '/a/reports/client-churn-report',
            },
            {
              title: 'Blocked Clients',
              roleValue: 'ADMIN_CLIENT_CHURN_REPORTS_VIEW',
              page: '/a/reports/blocked-client-report',
            },
          ],
        },
      },
      {
        title: 'Client Based Reports',
        icon: 'la-files-o',
        roleValue: 'ADMIN_TRANSACTIONS_REPORTS_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Transactions',
              roleValue: 'ADMIN_TRANSACTIONS_REPORTS_VIEW',
              page: '/a/client-reports/transcations-report',
            },
            {
              title: 'Expense-Volume',
              roleValue: 'ADMIN_EXPENSE_REPORTS_VIEW',
              page: '/a/client-reports/expense-volume-report',
            },
            {
              title: 'Revenue-Volume',
              roleValue: 'ADMIN_REVENUE_REPORTS_VIEW',
              page: '/a/client-reports/revenue-volume-report',
            },
            {
              title: 'Blocked-Corporates',
              roleValue: 'ADMIN_BLOCKED_CORPORATE_REPORTS_VIEW',
              page: '/a/client-reports/blocked-corporate-report',
            },
            {
              title: 'Blocked-Hotels',
              roleValue: 'ADMIN_BLOCKED_CORPORATE_REPORTS_VIEW',
              page: '/a/client-reports/blocked-hotels',
            },
          ],
        },
      },
      {},
      {},
      {},
      {},
      {
        title: 'User Management',
        icon: 'la la-group',
        roleValue: 'USER_MANAGEMENT_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Role Management',
              page: '/a/roles/list',
              roleValue: 'ROLE_MANAGEMENT_VIEW',
            },
            {
              title: 'User List',
              page: '/a/users/list',
              roleValue: 'USER_MANAGEMENT_VIEW',
            },
          ],
        },
      },
      {},
      {},
      {},
      {},
      {
        title: 'Subscription',
        roleValue: 'ADMIN_SUBSCRIPTION_VIEW',
        icon: 'la la-empire',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'View Subscription',
              roleValue: 'ADMIN_SUBSCRIPTION_VIEW',
              page: '/a/subscription/view-subscription',
            },
            {
              title: 'Subscription Management',
              roleValue: 'ADMIN_SUBSCRIPTION_VIEW',
              page: '/a/subscription/sub-management',
            },
          ],
        },
      },
      // {
      //   title: 'FAQ',
      //   icon: 'la-question',
      //   roleValue: "HOME_VIEW",
      //   page: 'faq/faqs',
      // },
      {
        title: 'Confirmed Transactions',
        icon: 'la la-book',
        page: 'null',
        roleValue: 'HOTEL_CONFIRM_ROOM_BOOKING_VIEW',
        submenu: {
          items: [
            {
              title: 'Room Bookings',
              page: '/h/confirm/confirm-room',
              roleValue: 'HOTEL_CONFIRM_ROOM_BOOKING_VIEW',
            },
            {
              title: 'Group Bookings',
              page: '/h/confirm/confirm-group',
              roleValue: 'HOTEL_CONFIRM_GROUP_BOOKING_VIEW',
            },
            {
              title: ' Banquet Bookings',
              page: '/h/confirm/confirm-banquet',
              roleValue: 'HOTEL_CONFIRM_BANQUET_BOOKING_VIEW',
            },
          ],
        },
      },
      {
        title: 'Pending Transactions ',
        icon: 'la la-th-list',
        page: 'null',
        roleValue: 'HOTEL_ROOM_BOOKING_VIEW',
        submenu: {
          items: [
            {
              title: 'Room Bookings',
              page: '/h/pending/room-list',
              roleValue: 'HOTEL_ROOM_BOOKING_VIEW',
            },
            {
              title: 'Group Bookings',
              page: '/h/pending/groups-list',
              roleValue: 'HOTEL_GROUP_BOOKING_VIEW',
            },
            {
              title: 'Banquet Bookings',
              page: '/h/pending/banquet-list',
              roleValue: 'HOTEL_BANQUET_BOOKING_VIEW',
            },
          ],
        },
      },
      {
        title: 'Check-Out',
        icon: ' la la-sign-out',
        page: 'null',
        roleValue: 'HOTEL_CHECKOUT_ROOM_VIEW',
        submenu: {
          items: [
            {
              title: 'Rooms',
              page: '/h/checkout/checkout-room',
              roleValue: 'HOTEL_CHECKOUT_ROOM_VIEW',
            },
            {
              title: ' Groups',
              page: '/h/checkout/checkout-group',
              roleValue: 'HOTEL_CHECKOUT_GROUP_VIEW',
            },
            {
              title: ' Banquets',
              page: '/h/checkout/checkout-banquet',
              roleValue: 'HOTEL_CHECKOUT_BANQUET_VIEW',
            },
          ],
        },
      },
      {
        title: 'Operations',
        icon: 'la la-arrow-circle-o-right',
        page: 'null',
        roleValue: 'HOTEL_CORPORATE_NEW_VIEW',
        submenu: {
          items: [
            {
              title: 'Room Inventory',
              roleValue: 'HOTEL_CORPORATE_MANAGE_VIEW',
              page: '/h/operation/room/inventory/list',
            },
            {
              title: 'New Corporates',
              page: '/h/operation/new-corporate',
              roleValue: 'HOTEL_CORPORATE_NEW_VIEW',
            },
            {
              title: 'Link Corporates',
              roleValue: 'HOTEL_CORPORATE_LINK_VIEW',
              page: '/h/operation/link-corporate',
            },
            {
              title: 'Manage Corporates',
              roleValue: 'HOTEL_CORPORATE_MANAGE_VIEW',
              page: '/h/operation/manage-corporate',
            },
            {
              title: 'Corporate-Wise-Receivables',
              roleValue: 'HOTEL_CORPORATE_MANAGE_VIEW',
              page: '/h/operation/corporate-wise',
            },
          ],
        },
      },

      {
        title: 'Master',
        icon: 'la la-user-secret',
        page: 'null',
        roleValue: 'HOTEL_MASTER_VIEW',
        submenu: {
          items: [
            {
              title: 'Hotel Master',
              page: '/h/master/hotel',
              roleValue: 'HOTEL_MASTER_VIEW',
            },
            {
              title: 'Banquet Master',
              page: '/h/master/banquet',
              roleValue: 'BANQUET_MASTER_VIEW',
            },
          ],
        },
      },
      {
        title: 'Reports',
        icon: 'la la-file-text-o',
        roleValue: 'HOTEL_RESERVE_REPORT_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Reservations Report',
              roleValue: 'HOTEL_RESERVE_REPORT_VIEW',
              page: '/h/reports/reserve-report',
            },
            {
              title: 'Amendment Report',
              roleValue: 'HOTEL_AMENDMENT_REPORT_VIEW',
              page: '/h/reports/amendment-report',
            },
            {
              title: 'Cancellations Report',
              roleValue: 'HOTEL_CANCELLATION_REPORT_VIEW',
              page: '/h/reports/cancel-report',
            },
            {
              title: 'Check-Out Report',
              roleValue: 'HOTEL_CHECKOUT_REPORT_VIEW',
              page: '/h/reports/checkout-report',
            },
            {
              title: 'Contribution Report',
              roleValue: 'HOTEL_CONTRIBUTION_REPORT_VIEW',
              page: '/h/reports/contribution-report',
            },
            {
              title: 'Blocked Corporates Report',
              roleValue: 'HOTEL_BLOCKED_CORPORATE_REPORT_VIEW',
              page: '/h/reports/blocked-report',
            },
          ],
        },
      },

      {
        title: 'Subscription',
        icon: 'la la-empire',
        roleValue: 'HOTEL_SUBSCRIPTION_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Subscription',
              roleValue: 'HOTEL_SUBSCRIPTION_VIEW',
              page: '/h/subscription/list',
            },
          ],
        },
      },
      {
        title: 'User Registration',
        icon: 'la la-user-plus',
        roleValue: 'HOTEL_USER_VIEW',
        page: 'h/user/list',
      },

      // {
      //   title: 'Trip Summary',
      //   icon: 'la la-film',
      //   roleValue: 'HOTEL_TRIP_SUMMARY_VIEW',
      //   page: '/trip-summary/list',
      // },

      // Corporate  menu-Side Navigation//
      {
        title: 'Browse Hotels',
        icon: 'la la-building',
        roleValue: 'CORPORATE_ROOM_BOOKING_REQ_VIEW',
        page: 'c/browsehotel/all',
      },
      {
        title: 'Room Bookings',
        icon: 'la la-hotel',
        roleValue: 'CORPORATE_ROOM_BOOKING_REQ_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Booking Requests',
              roleValue: 'CORPORATE_ROOM_BOOKING_REQ_VIEW',
              page: 'c/room/requests',
            },

            {
              title: 'Pending Bookings ',
              roleValue: 'CORPORATE_ROOM_BOOKING_PENDING_VIEW',
              page: 'c/room/pending',
            },
            {
              title: 'Confirmed Bookings ',
              roleValue: 'CORPORATE_ROOM_BOOKING_CONFIRMED_VIEW',
              page: 'c/room/confirmed',
            },
          ],
        },
      },
      {
        title: 'Group Bookings',
        icon: 'la la-th-large',
        roleValue: 'CORPORATE_GROUP_BOOKING_REQ_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Booking Requests',
              roleValue: 'CORPORATE_GROUP_BOOKING_REQ_VIEW',
              page: 'c/group/requests',
            },
            {
              title: 'Pending Bookings',
              roleValue: 'CORPORATE_GROUP_BOOKING_PENDING_VIEW',
              page: 'c/group/pending',
            },
            {
              title: 'Confirmed Bookings',
              roleValue: 'CORPORATE_GROUP_BOOKING_PENDING_VIEW',
              page: 'c/group/confirmed',
            },
          ],
        },
      },
      {
        title: 'Banquet Bookings',
        roleValue: 'CORPORATE_BANQUET_BOOKING_REQ_VIEW',
        icon: 'la la-building',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Booking Requests',
              roleValue: 'CORPORATE_BANQUET_BOOKING_REQ_VIEW',
              page: 'c/banquet/requests',
            },
            {
              title: 'Pending Bookings ',
              roleValue: 'CORPORATE_BANQUET_BOOKING_PENDING_VIEW',
              page: 'c/banquet/pending',
            },
            {
              title: 'Confirmed Bookings ',
              roleValue: 'CORPORATE_BANQUET_BOOKING_PENDING_VIEW',
              page: 'c/banquet/confirmed',
            },
          ],
        },
      },

      // {
      //   title: 'Expense ',
      //   icon: 'la la-film',
      //   roleValue: 'CORPORATE_MASTER_VIEW',
      //   page: 'null',
      //   submenu: {
      //     items: [
      //       {
      //         title: 'Expense Management',
      //         page: 'c/expense-management/expense-mngt',
      //       }
      //     ]
      //   }
      // },
      // {
      //   title: 'Budget',
      //   icon: 'la la-film',
      //   roleValue: 'CORPORATE_MASTER_VIEW',
      //   page: 'null',
      //   submenu: {
      //     items: [
      //       {
      //         title: 'Budget Management',
      //         roleValue: 'CORPORATE_MASTER_VIEW',
      //         page: 'c/budget-management/list',
      //       },
      //       {
      //         title: 'Budget Master',
      //         roleValue: 'CORPORATE_MASTER_VIEW',
      //         page: 'c/budget-management/budget-master',
      //       },
      //     ]
      //   }
      // },
      {
        title: 'Master',
        icon: 'la la-male',
        roleValue: 'CORPORATE_MASTER_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Corporate',
              roleValue: 'CORPORATE_MASTER_VIEW',
              page: 'c/corporate/list',
            },
            {
              title: 'Policy',
              roleValue: 'CORPORATE_POLICY_VIEW',
              page: 'c/corporate/policy',
            },
            {
              title: 'Budget',
              page: 'c/corporate/budget/list',
              roleValue: 'CORPORATE_MASTER_VIEW',
            },
            // {
            //   title: 'Budget',
            //   icon: 'la la-film',
            //   roleValue: 'CORPORATE_MASTER_VIEW',
            //   page: 'null',
            //   submenu: {
            //     items: [
            //       {
            //         title: 'Budget Master ',
            //         roleValue: 'CORPORATE_MASTER_VIEW',
            //         page: 'c/corporate/budget/list',
            //       },
            //
            //       // {
            //       //   title: 'Temp Expense Management',
            //       //   roleValue: 'CORPORATE_MASTER_VIEW',
            //       //   page: 'c/budget-management/temp-expense',
            //       // },
            //     ]
            //   }
            // },
            {
              title: 'Master Settings',
              page: 'c/corporate/tenant/masters',
              roleValue: 'CORPORATE_MASTER_VIEW',
            },
            {
              title: 'Role Management',
              page: 'c/corporate/role/list',
              roleValue: 'CORPORATE_MASTER_VIEW',
            },
          ],
        },
      },
      {
        title: 'Operations',
        icon: 'la la-sliders',
        roleValue: 'CORPORATE_HOTEL_NEW_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'New Hotels',
              roleValue: 'CORPORATE_HOTEL_NEW_VIEW',
              page: 'c/operations/hotels/new',
            },
            {
              title: 'Link Hotels',
              roleValue: 'CORPORATE_HOTEL_LINK_VIEW',
              page: 'c/operations/hotels/link',
            },
            {
              title: 'Manage Hotels',
              roleValue: 'CORPORATE_HOTEL_MANAGE_VIEW',
              page: 'c/operations/hotels/manage',
            },
            {
              title: 'Ongoing Payments',
              roleValue: 'CORPORATE_POLICY_VIEW',
              page: 'c/operations/payments',
            },
            {
              title: 'Budget Management',
              roleValue: 'CORPORATE_MASTER_VIEW',
              page: 'c/corporate/budget/management-list',
            },
          ],
        },
      },

      {
        title: 'Trip Summary',
        icon: 'la la-film',
        roleValue: 'CORPORATE_MASTER_VIEW',
        page: 'c/employee/trip-summary',
      },
      {
        title: 'Reports',
        icon: 'la la-sticky-note-o',
        roleValue: 'CORPORATE_TRAVEL_REQ_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'Travel Requests',
              roleValue: 'CORPORATE_TRAVEL_REQ_VIEW',
              page: 'c/reports/travel/request',
            },
            {
              title: 'Travel Bookings ',
              roleValue: 'CORPORATE_TRAVEL_BOOKING_VIEW',
              page: 'c/reports/travel/booking',
            },
            {
              title: 'Hotel-Wise Expense ',
              roleValue: 'CORPORATE_HOTEL_EXPENSE_VIEW',
              page: 'c/reports/expense/hotel',
            },
            {
              title: 'City-Wise Expense ',
              roleValue: 'CORPORATE_CITY_EXPENSE_VIEW',
              page: 'c/reports/expense/city',
            },
            {
              title: 'Employee-Wise Expense ',
              roleValue: 'CORPORATE_EMPLOYEE_EXPENSE_VIEW',
              page: 'c/reports/expense/employee',
            },
            {
              title: 'Department-wise Expense ',
              roleValue: 'CORPORATE_DEPARTMENT_EXPENSE_VIEW',
              page: 'c/reports/expense/department',
            },
          ],
        },
      },

      {
        title: 'User Registration',
        icon: 'la la-user-plus',
        roleValue: 'CORPORATE_USER_MANAGEMENT_VIEW',
        page: 'c/user/registration',
      },
      {
        title: 'Subscriptions',
        icon: 'la la-yelp',
        roleValue: 'CORPORATE_SUBSCRIPTION_VIEW',
        page: 'c/subscription/list',
      },
      {
        icon: ' la la-file-word-o',
        title: 'Pending Approvals',
        roleValue: 'CORPORATE_ROOM_APPROVER_REQ_VIEW',
        page: 'c/approver/pending/approval',
      },
      {
        icon: ' la la-columns',
        title: 'Approved Trips',
        roleValue: 'CORPORATE_ROOM_APPROVER_PENDING_VIEW',
        page: 'c/approver/approved/trips',
      },
      // {
      //   title: 'Trip Summary',
      //   roleValue: 'CORPORATE_ROOM_APPROVER_PENDING_VIEW',
      //   page: 'c/approver/trip/summary',
      // },
      {
        icon: '  la la-database',
        title: 'Approval Summary',
        roleValue: 'CORPORATE_ROOM_APPROVER_PENDING_VIEW',
        page: 'c/approver/approval/summary',
      },
      {
        icon: '  la la-database',
        title: 'Expense Summary',
        roleValue: 'CORPORATE_ROOM_APPROVER_PENDING_VIEW',
        page: 'c/approver/expense-summary',
      },
      {
        icon: '  la la-car',
        title: 'Trip Summary',
        roleValue: 'CORPORATE_ROOM_APPROVER_PENDING_VIEW',
        // page: 'c/approver/trip-summary',
        page: 'c/employee/trip-summary',
      },
      // {
      //   title: 'Approver',
      //   roleValue: 'CORPORATE_ROOM_BOOKING_REQ_VIEW',
      //   icon: 'la la-street-view',
      //   page: 'null',
      //   submenu: {
      //     items: [
      //       {
      //         title: 'Approval Summary',
      //         roleValue: 'CORPORATE_ROOM_BOOKING_REQ_VIEW',
      //         page: 'c/approver/approval/summary',
      //       },
      //       {
      //         title: 'Approved Trips',
      //         roleValue: 'CORPORATE_ROOM_BOOKING_PENDING_VIEW',
      //         page: 'c/approver/approved/trips',
      //       },
      //       {
      //         title: 'Pending Approval',
      //         roleValue: 'CORPORATE_ROOM_BOOKING_PENDING_VIEW',
      //         page: 'c/approver/pending/approval',
      //       },
      //       {
      //         title: 'Trip Summary',
      //         roleValue: 'CORPORATE_ROOM_BOOKING_PENDING_VIEW',
      //         page: 'c/approver/trip/summary',
      //       },
      //     ]
      //   }
      // },

      {
        icon: 'la la-inbox',
        title: 'Booking Requests',
        roleValue: 'CORPORATE_EMPLOYEE_VIEW',
        page: 'c/employee/booking-requests',
      },
      {
        icon: 'la la-inbox',
        title: 'Booking Requests (Legs)',
        roleValue: 'CORPORATE_EMPLOYEE_LEGS_VIEW',
        page: 'c/employee/booking-requests-legs',
      },
      {
        icon: ' la la-file-word-o',
        title: 'Scheduled',
        roleValue: 'CORPORATE_EMPLOYEE_SCHEDULED_BOOKING_VIEW',
        page: 'null',
        submenu: {
          items: [
            {
              title: 'In-Progress Bookings',
              roleValue: 'CORPORATE_EMPLOYEE_SCHEDULED_BOOKING_PENDING_VIEW',
              page: 'c/employee/scheduled-inprogres',
            },
            {
              title: 'Confirmed Bookings',
              roleValue: 'CORPORATE_EMPLOYEE_SCHEDULED_BOOKING_CONFIRMED_VIEW',
              page: 'c/employee/scheduled-confirmed',
            },
          ],
        },
      },
      {
        icon: 'la la-film',
        title: 'Request Summary',
        roleValue: 'CORPORATE_EMPLOYEE_REQ_SUMMARY_VIEW',
        page: 'c/employee/requests-summary',
      },
      {
        icon: ' la la-car',
        title: 'Trip Summary',
        roleValue: 'CORPORATE_EMPLOYEE_VIEW',
        page: 'c/employee/trip-summary',
      },
      {
        icon: ' la la-user',
        title: 'Profile',
        roleValue: 'CORPORATE_EMPLOYEE_PROFILE_VIEW',
        page: 'c/employee/profile',
      },
      {
        title: 'FAQ',
        icon: 'la-question',
        roleValue: 'HOME_VIEW',
        page: 'faq/list',
      },

      // {
      //   title: 'Employees',
      //   icon: 'la la-slideshare',
      //   roleValue: 'CORPORATE_EMPLOYEE_VIEW',
      //   page: 'null',
      //   submenu: {
      //     items: [
      //       {
      //         title: 'Booking Requets',
      //         roleValue: 'CORPORATE_EMPLOYEE_VIEW',
      //         page: 'c/employee/booking-requests'
      //       },
      //       {
      //         title: 'Profile',
      //         roleValue: 'CORPORATE_EMPLOYEE_PROFILE_VIEW',
      //         page: 'c/employee/profile'
      //       },
      //       {
      //         title: 'Requests Summary',
      //         roleValue: 'CORPORATE_EMPLOYEE_REQ_SUMMARY_VIEW',
      //         page: 'c/employee/requests-summary',
      //       },
      //       {
      //         title: 'Scheduled Booking',
      //         roleValue: 'CORPORATE_EMPLOYEE_SCHEDULED_BOOKING_VIEW',
      //         page: 'null',
      //         submenu: {
      //           items: [
      //             {
      //               title: 'In Progress',
      //               roleValue: 'CORPORATE_EMPLOYEE_SCHEDULED_BOOKING_PENDING_VIEW',
      //               page: 'c/employee/scheduled-inprogres',
      //             },
      //             {
      //               title: 'Confirmed',
      //               roleValue: 'CORPORATE_EMPLOYEE_SCHEDULED_BOOKING_CONFIRMED_VIEW',
      //               page: 'c/employee/scheduled-confirmed',
      //             },
      //           ]
      //         }
      //       },
      //       {
      //         title: 'Trip Summary',
      //         roleValue: 'CORPORATE_EMPLOYEE_TRIP_SUMMARY_VIEW',
      //         page: 'c/employee/trip-summary',
      //       },
      //     ]
      //   }
      // },
    ],
  },
};
